import { useTranslation } from 'react-i18next';
import limpiarHtml from '../Compartido/limpiarHtml.js';
import { RUTA_IMATGES } from '../Compartido/contenidoCamprodon.js';

const Fletxa = ({ costat }) => (
    <svg aria-hidden="true" focusable="false" className="c-icon" width="37" height="11">
        <use href={RUTA_IMATGES + "icons-sprite.svg#sprite-icon-arrow-slider-" + costat}></use>
    </svg>
);

// Llista d'habitacions de la pàgina Habitacions amb les propietats destacades
// de la web (PaginasController::propiedadesDestacadas): les mateixes targetes
// que l'original. El slider de fotos (data-slider) el fa ContenidoPagina.
const Habitaciones = ({ habitaciones, ruta, lang, rutaFitxa }) => {

    const { t } = useTranslation();

    if (!habitaciones || habitaciones.length === 0) return null;

    return (
        <section className="rooms o-container">
            <div className="rooms--category c-cards-list">
                {habitaciones.map((propiedad, index) => {
                    const fotos = propiedad.fotos_web && propiedad.fotos_web.length > 0 ? propiedad.fotos_web : [{ nombre: null }];
                    const idSlider = "habitacio-fotos-" + index;
                    const href = rutaFitxa(propiedad);
                    const boto = propiedad.by_request == 1 ? "Petición" : "Reservar";

                    return (
                        <article className="c-card" key={propiedad.id ?? index}>
                            <div className="c-card__header">
                                <div className="c-slider-controls-above c-slider-controls-above--bottom-right">
                                    <div id={idSlider}>
                                        {fotos.map((foto, i) => (
                                            <picture key={i}>
                                                <img
                                                    src={foto.nombre ? ruta + "/propiedades/" + propiedad.id + "/fotos/web/" + foto.nombre : "/images/web/bedloop-nofoto.png"}
                                                    alt={(foto.texto_alt && foto.texto_alt[lang]) || propiedad.nombre}
                                                    className="image-cover"
                                                    width="100%"
                                                    height="100%"
                                                    loading="lazy"
                                                    decoding="async"
                                                />
                                            </picture>
                                        ))}
                                    </div>
                                    {fotos.length > 1 && (
                                        <div data-slider={"#" + idSlider} className="c-slider-controls c-slider-controls--white d-flex-center">
                                            <button className="c-slider-controls__button c-slider-controls__button--prev d-flex-center" aria-label="Previous slide"><Fletxa costat="left" /></button>
                                            <button className="c-slider-controls__button d-flex-center" aria-label="Next slide"><Fletxa costat="right" /></button>
                                            <div className="c-slider-index">
                                                <span className="c-slider-index__item c-slider-index__item--current-index js-current-index">1</span>
                                                <span className="c-slider-index__item c-slider-index__item--total-slides js-total-slides"></span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="c-card__body">
                                <div className="c-card__content">
                                    <h2 className="c-card__title">{propiedad.nombre}</h2>
                                    {propiedad.ladesccorta && <div dangerouslySetInnerHTML={{ __html: limpiarHtml(propiedad.ladesccorta) }}></div>}
                                </div>
                                <div className="c-card__footer">
                                    <a href={href} className="c-link">{t("Descubrir")}</a>
                                    <a href={href} className="c-button c-button--primary c-button--large d-flex-center">{t(boto)}</a>
                                </div>
                            </div>
                        </article>
                    );
                })}
            </div>
        </section>
    );
};

export default Habitaciones;
